module.exports = __webpack_public_path__ + "static/media/butcher-2.15557940.png";